/* @flow weak*/
import _ from "lodash";
import { SessionStore } from "../uidispatcherapi/SessionStore";

const shopRegex = /^(\/ordercapture\/uidispatcher\/static)?\/shop/;

let hash = false;
try {
    require("../uidispatcherapi/BettyHistoryModule");
} catch (e) {
    hash = true;
}

const UrlUtil = {
    isBackendUrl(pathname: string) {
        return !pathname.match(shopRegex);
    },

    getRelativePathForRedirectAfterLogin(location: { [x: string]: any }) {
        return "/login" + location.pathname;
    },

    /**
     * replaces "/backend" by "/shop" in the url and vice versa.
     */
    getOtherLoginUrl(pathname: string) {
        if (pathname.match(shopRegex)) {
            if (hash) {
                return "/ordercapture/uidispatcher/static/backend#/exlogin";
            }
            return "/ordercapture/uidispatcher/static/backend/exlogin";
        } else {
            if (hash) {
                return "/ordercapture/uidispatcher/static/shop#/exlogin";
            }
            return "/ordercapture/uidispatcher/static/shop/exlogin";
        }
    },

    manualXMLHttpRequest: function(
        url: string,
        method: any,
        content: any,
        completed: any,
        failure: any,
        timeout: any,
        callTreeId: string | null
    ) {
        this.manualXMLHttpRequestInternal(
            new XMLHttpRequest(),
            url,
            method,
            content,
            completed,
            failure,
            timeout,
            callTreeId
        );
    },

    manualXMLHttpRequestInternal: function(
        xhttp: any,
        url: string,
        method: any,
        content: any,
        completed: any,
        failure: any,
        timeout: any,
        callTreeId: string | null
    ) {
        xhttp.open(method, url, true);
        if (!callTreeId) {
            callTreeId = SessionStore.generateSessionedCallTreeIdWithPrefix("???PLAT");
        }
        xhttp.setRequestHeader("Content-type", "application/json; charset=utf-8");
        xhttp.setRequestHeader("CallTreeId", callTreeId);
        xhttp.onreadystatechange = function() {
            if (xhttp.readyState === 4) {
                if (xhttp.status === 200) {
                    completed.call(xhttp, xhttp);
                } else {
                    failure.call(xhttp, xhttp);
                }
            }
        };
        xhttp.timeout = timeout;
        xhttp.ontimeout = function() {
            failure.call(xhttp, xhttp);
        };
        xhttp.send(content ? JSON.stringify(content) : undefined);
    },

    updateQueryStringParameter(uri: string, key: string, value: string) {
        const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        const separator = _.includes(uri, "?") ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, "$1" + key + "=" + value + "$2");
        } else {
            return uri + separator + key + "=" + value;
        }
    }
};

export default UrlUtil;
